// Module
var code = "<template>\n    <div show.bind=\"isActive\">\n        <h3 class=\"card-header\" if.bind=\"titleResource\" innerhtml.bind=\"title\"></h3>\n        <slot></slot>\n    </div>\n</template>\n";
// Exports
export default code;